var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiltersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16346 10.9038L8.16346 19.125M8.16346 4.875V7.06731M15.8365 16.9327V19.125M15.8365 4.875V13.0962M6.375 10.9039H9.95192C10.7803 10.9039 11.4519 10.2323 11.4519 9.40386V8.56732C11.4519 7.73889 10.7803 7.06732 9.95192 7.06732H6.375C5.54657 7.06732 4.875 7.73889 4.875 8.56732V9.40386C4.875 10.2323 5.54657 10.9039 6.375 10.9039ZM14.0481 16.9327H17.625C18.4534 16.9327 19.125 16.2611 19.125 15.4327V14.5962C19.125 13.7677 18.4534 13.0962 17.625 13.0962H14.0481C13.2196 13.0962 12.5481 13.7677 12.5481 14.5962V15.4327C12.5481 16.2611 13.2196 16.9327 14.0481 16.9327Z",
    stroke: "#5F4840",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filtersIcon.6ac44ea85dc7ae67ba29eb9a5fdf18fe.svg";
export { ForwardRef as ReactComponent };